import React from "react";
import { UserButtonMessage } from "@/components/Chat/ChatMessage/UserButtonMessage";
import { classNames } from "@/utils/utils";

import styles from "./UserErrorMessage.module.css";

type Props = {
  className?: string;
  disabled?: boolean;
  description: string;
  children?: React.ReactNode;
  onClick?: () => void;
};

export const UserErrorMessage: React.FC<Props> = ({
  onClick,
  disabled,
  description,
  className,
  children,
  ...rest
}) => {
  const [pressed, setPressed] = React.useState(false);

  return (
    <>
      <UserButtonMessage
        {...rest}
        disabled={disabled || pressed}
        className={classNames(styles.bubble, className)}
        onClick={() => {
          if (onClick) {
            setPressed(true);
            onClick();
          }
        }}
      >
        {children}
      </UserButtonMessage>
      {!pressed && <div className={styles.description}>{description}</div>}
    </>
  );
};
